import React from "react";
import PropTypes from "prop-types";

import { CompanyInfoForm } from "../../../../components/Company";

const Details = ({ editing, inputs, onChange }) => (
  <div>
    <CompanyInfoForm disabled={!editing} inputs={inputs} onChange={onChange} />
  </div>
);

Details.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func,
  editing: PropTypes.bool
};
export default Details;
